export const spinnerActionType = {
    SET_IS_FETCHING:"SET_IS_FETCHING",
}